import SubmissionDetails from './SubmissionDetails';
import SubmissionDetailsContainer from './SubmissionDetails.container';
import SubmissionDetailsV2Component from './SubmissionDetails.actionbar_phase_1';
import SubmissionDetailsV2Container from './SubmissionDetails.actionbar_phase_1.container';
export default SubmissionDetailsContainer(SubmissionDetails);
export var SubmissionDetailsV2 = SubmissionDetailsV2Container(SubmissionDetailsV2Component);
//# sourceMappingURL=index.js.map